export const mobile_info_details = [
	{
		id: 201,
		no: '2.3.1',
		label: 'ค่า Round Trip Time (RTT)',
		targeted_text: 'สำหรับ 2G ร้อยละ 80 ไม่เกิน 1,000 ms',
		subLabel_1: 'สำหรับ 2G ร้อยละ 80 ไม่เกิน 1,000 ms',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 80,
		targetCondition: 'ge',
		filling_condition:
			'ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: true,
		records: {
			rural_1: null,
			rural_2: null,
			urban_1: null,
			urban_2: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['D', 'E', 'F', 'G'],
		excelValueRow: 8,
		priority: 201,
	},
	{
		id: 202,
		no: '2.3.1',
		label: 'ค่า Round Trip Time (RTT)',
		targeted_text: 'สำหรับ 3G ร้อยละ 80 ไม่เกิน 500 ms',
		subLabel_1: 'สำหรับ 3G ร้อยละ 80 ไม่เกิน 500 ms',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 80,
		targetCondition: 'ge',
		filling_condition:
			'ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: true,
		records: {
			rural_1: null,
			rural_2: null,
			urban_1: null,
			urban_2: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['D', 'E', 'F', 'G'],
		excelValueRow: 12,
		priority: 202,
	},
	{
		id: 203,
		no: '2.3.1',
		label: 'ค่า Round Trip Time (RTT)',
		targeted_text: 'สำหรับ 4G ขึ้นไป ร้อยละ 80 ไม่เกิน 150 ms',
		subLabel_1: 'สำหรับ 4G ขึ้นไป ร้อยละ 80 ไม่เกิน 150 ms',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 80,
		targetCondition: 'ge',
		filling_condition:
			'ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: true,
		records: {
			rural_1: null,
			rural_2: null,
			urban_1: null,
			urban_2: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['D', 'E', 'F', 'G'],
		excelValueRow: 16,
		priority: 203,
	},
	{
		id: 204,
		no: '2.3.2',
		label: 'อัตราส่วนจำนวนครั้งที่ใช้ FTP ได้สำเร็จ (FTP success ratio)',
		targeted_text: 'กรณี Download สำหรับ 3G ไม่ต่ำกว่าร้อยละ 80',
		subLabel_1: 'กรณี Download สำหรับ 3G ไม่ต่ำกว่าร้อยละ 80',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 80,
		targetCondition: 'ge',
		filling_condition:
			'ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: true,
		records: {
			rural_1: null,
			rural_2: null,
			urban_1: null,
			urban_2: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['D', 'E', 'F', 'G'],
		excelValueRow: 21,
		priority: 204,
	},
	{
		id: 205,
		no: '2.3.2',
		label: 'อัตราส่วนจำนวนครั้งที่ใช้ FTP ได้สำเร็จ (FTP success ratio)',
		targeted_text: 'กรณี Download สำหรับ 4G ขึ้นไป ไม่ต่ำกว่าร้อยละ 80',
		subLabel_1: 'กรณี Download สำหรับ 4G ขึ้นไป ไม่ต่ำกว่าร้อยละ 80',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 80,
		targetCondition: 'ge',
		filling_condition:
			'ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: true,
		records: {
			rural_1: null,
			rural_2: null,
			urban_1: null,
			urban_2: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['D', 'E', 'F', 'G'],
		excelValueRow: 25,
		priority: 205,
	},
	{
		id: 206,
		no: '2.3.2',
		label: 'อัตราส่วนจำนวนครั้งที่ใช้ FTP ได้สำเร็จ (FTP success ratio)',
		targeted_text: 'กรณี Upload สำหรับ 3G ไม่ต่ำกว่าร้อยละ 70',
		subLabel_1: 'กรณี Upload สำหรับ 3G ไม่ต่ำกว่าร้อยละ 70',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 70,
		targetCondition: 'ge',
		filling_condition:
			'ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: true,
		records: {
			rural_1: null,
			rural_2: null,
			urban_1: null,
			urban_2: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['D', 'E', 'F', 'G'],
		excelValueRow: 29,
		priority: 206,
	},
	{
		id: 207,
		no: '2.3.2',
		label: 'อัตราส่วนจำนวนครั้งที่ใช้ FTP ได้สำเร็จ (FTP success ratio)',
		targeted_text: 'กรณี Upload สำหรับ 4G ขึ้นไป ไม่ต่ำกว่าร้อยละ 70',
		subLabel_1: 'กรณี Upload สำหรับ 4G ขึ้นไป ไม่ต่ำกว่าร้อยละ 70',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 70,
		targetCondition: 'ge',
		filling_condition:
			'ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: true,
		records: {
			rural_1: null,
			rural_2: null,
			urban_1: null,
			urban_2: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['D', 'E', 'F', 'G'],
		excelValueRow: 33,
		priority: 207,
	},
	{
		id: 208,
		no: '2.3.3',
		label:
			'อัตราส่วนของการรับส่งข้อมูลแบบ FTP ตามความเร็วเฉลี่ยในการส่งข้อมูลที่กำหนด (FTP ratio subjected to specified data rate)',
		targeted_text: 'กรณี Download สำหรับ 3G ร้อยละ 75 ไม่ต่ำกว่า 750 kbps',
		subLabel_1: 'กรณี Download สำหรับ 3G ร้อยละ 75',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 75,
		targetCondition: 'ge',
		filling_condition:
			'ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: true,
		records: {
			rural_1: null,
			rural_2: null,
			urban_1: null,
			urban_2: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['D', 'E', 'F', 'G'],
		excelValueRow: 38,
		priority: 208,
	},
	{
		id: 223,
		no: '2.3.3',
		label:
			'',
		targeted_text: '',
		subLabel_1: 'ไม่ต่ำกว่า 750 kbps',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 750,
		targetCondition: 'ge',
		filling_condition:
			'',
		isNeedAnswer: true,
		records: {
			rural_1: null,
			rural_2: null,
			urban_1: null,
			urban_2: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['D', 'E', 'F', 'G'],
		excelValueRow: 41,
		priority: 208.1,
	},
	{
		id: 209,
		no: '2.3.3',
		label:
			'อัตราส่วนของการรับส่งข้อมูลแบบ FTP ตามความเร็วเฉลี่ยในการส่งข้อมูลที่กำหนด (FTP ratio subjected to specified data rate)',
		targeted_text:
			'กรณี Download สำหรับ 4G ขึ้นไป ร้อยละ 75 ไม่ต่ำกว่า 2.5 Mbps',
		subLabel_1: 'กรณี Download สำหรับ 4G ขึ้นไป ร้อยละ 75',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 75,
		targetCondition: 'ge',
		filling_condition:
			'ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: true,
		records: {
			rural_1: null,
			rural_2: null,
			urban_1: null,
			urban_2: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['D', 'E', 'F', 'G'],
		excelValueRow: 42,
		priority: 209,
	},
	{
		id: 224,
		no: '2.3.3',
		label:
			'',
		targeted_text: '',
		subLabel_1: 'ไม่ต่ำกว่า 2.5 Mbps',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 2.5,
		targetCondition: 'ge',
		filling_condition:
			'',
		isNeedAnswer: true,
		records: {
			rural_1: null,
			rural_2: null,
			urban_1: null,
			urban_2: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['D', 'E', 'F', 'G'],
		excelValueRow: 45,
		priority: 209.1,
	},
	{
		id: 210,
		no: '2.3.3',
		label:
			'อัตราส่วนของการรับส่งข้อมูลแบบ FTP ตามความเร็วเฉลี่ยในการส่งข้อมูลที่กำหนด (FTP ratio subjected to specified data rate)',
		targeted_text: 'กรณี Upload สำหรับ 3G ร้อยละ 75 ไม่ต่ำกว่า 300 kbps',
		subLabel_1: 'กรณี Upload สำหรับ 3G ร้อยละ 75 ไม่ต่ำกว่า 300 kbps',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 75,
		targetCondition: 'ge',
		filling_condition:
			'ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: true,
		records: {
			rural_1: null,
			rural_2: null,
			urban_1: null,
			urban_2: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['D', 'E', 'F', 'G'],
		excelValueRow: 46,
		priority: 210,
	},
	{
		id: 225,
		no: '2.3.3',
		label:
			'',
		targeted_text: '',
		subLabel_1: 'ไม่ต่ำกว่า 300 kbps',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 300,
		targetCondition: 'ge',
		filling_condition:
			'',
		isNeedAnswer: true,
		records: {
			rural_1: null,
			rural_2: null,
			urban_1: null,
			urban_2: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['D', 'E', 'F', 'G'],
		excelValueRow: 49,
		priority: 210.1,
	},
	{
		id: 211,
		no: '2.3.3',
		label:
			'อัตราส่วนของการรับส่งข้อมูลแบบ FTP ตามความเร็วเฉลี่ยในการส่งข้อมูลที่กำหนด (FTP ratio subjected to specified data rate)',
		targeted_text: 'กรณี Upload สำหรับ 4G ขึ้นไป ร้อยละ 75 ไม่ต่ำกว่า 500 kbps',
		subLabel_1: 'กรณี Upload สำหรับ 4G ขึ้นไป ร้อยละ 75',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 75,
		targetCondition: 'ge',
		filling_condition:
			'ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: true,
		records: {
			rural_1: null,
			rural_2: null,
			urban_1: null,
			urban_2: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['D', 'E', 'F', 'G'],
		excelValueRow: 50,
		priority: 211,
	},
	{
		id: 226,
		no: '2.3.3',
		label:
			'',
		targeted_text: '',
		subLabel_1: 'ไม่ต่ำกว่า 500 kbps',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 500,
		targetCondition: 'ge',
		filling_condition:
			'',
		isNeedAnswer: true,
		records: {
			rural_1: null,
			rural_2: null,
			urban_1: null,
			urban_2: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['D', 'E', 'F', 'G'],
		excelValueRow: 53,
		priority: 209.1,
	},
	{
		id: 212,
		no: '2.3.4',
		label: 'อัตราส่วนจำนวนครั้งที่ HTTP โหลดได้สำเร็จ (HTTP success ratio)',
		targeted_text: 'สำหรับ 2G ร้อยละ 80 ไม่เกิน 10 นาที',
		subLabel_1: 'สำหรับ 2G ร้อยละ 80 ไม่เกิน 10 นาที',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 80,
		targetCondition: 'ge',
		filling_condition:
			'ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: true,
		records: {
			rural_1: null,
			rural_2: null,
			urban_1: null,
			urban_2: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['D', 'E', 'F', 'G'],
		excelValueRow: 55,
		priority: 212,
	},
	{
		id: 213,
		no: '2.3.4',
		label: 'อัตราส่วนจำนวนครั้งที่ HTTP โหลดได้สำเร็จ (HTTP success ratio)',
		targeted_text: 'สำหรับ 3G ร้อยละ 90 ไม่เกิน 3 นาที',
		subLabel_1: 'สำหรับ 3G ร้อยละ 90 ไม่เกิน 3 นาที',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 90,
		targetCondition: 'ge',
		filling_condition:
			'ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: true,
		records: {
			rural_1: null,
			rural_2: null,
			urban_1: null,
			urban_2: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['D', 'E', 'F', 'G'],
		excelValueRow: 59,
		priority: 213,
	},
	{
		id: 214,
		no: '2.3.4',
		label: 'อัตราส่วนจำนวนครั้งที่ HTTP โหลดได้สำเร็จ (HTTP success ratio)',
		targeted_text: 'สำหรับ 4G ขึ้นไป ร้อยละ 90 ไม่เกิน 1 นาที',
		subLabel_1: 'สำหรับ 4G ขึ้นไป ร้อยละ 90 ไม่เกิน 1 นาที',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 90,
		targetCondition: 'ge',
		filling_condition:
			'ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: true,
		records: {
			rural_1: null,
			rural_2: null,
			urban_1: null,
			urban_2: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['D', 'E', 'F', 'G'],
		excelValueRow: 63,
		priority: 214,
	},
	{
		id: 215,
		no: '2.3.5',
		label:
			'อัตราส่วนจำนวนครั้งที่สามารถเข้าถึงบริการสตรีมมิ่ง (Streaming service accessibility)',
		targeted_text: 'สำหรับ 3G (Resolution 360p) ยังไม่กำหนดค่าเป้าหมาย',
		subLabel_1: 'สำหรับ 3G (Resolution 360p) ยังไม่กำหนดค่าเป้าหมาย',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		filling_condition:
			'ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: true,
		records: {
			rural_1: null,
			rural_2: null,
			urban_1: null,
			urban_2: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['D', 'E', 'F', 'G'],
		excelValueRow: 68,
		priority: 215,
	},
	{
		id: 216,
		no: '2.3.5',
		label:
			'อัตราส่วนจำนวนครั้งที่สามารถเข้าถึงบริการสตรีมมิ่ง (Streaming service accessibility)',
		targeted_text: 'สำหรับ 4G (Resolution 720p) ยังไม่กำหนดค่าเป้าหมาย',
		subLabel_1: 'สำหรับ 4G (Resolution 720p) ยังไม่กำหนดค่าเป้าหมาย',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		filling_condition:
			'ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: true,
		records: {
			rural_1: null,
			rural_2: null,
			urban_1: null,
			urban_2: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['D', 'E', 'F', 'G'],
		excelValueRow: 72,
		priority: 216,
	},
	{
		id: 217,
		no: '2.3.6',
		label:
			'อัตราส่วนจำนวนครั้งการแสดงวีดีทัศน์แบบสตรีมมิ่งได้อย่างสมบูรณ์ (Streaming reproduction success ratio)',
		targeted_text: 'สำหรับ 3G (Resolution 360p) ยังไม่กำหนดค่าเป้าหมาย',
		subLabel_1: 'สำหรับ 3G (Resolution 360p) ยังไม่กำหนดค่าเป้าหมาย',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		filling_condition:
			'ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: true,
		records: {
			rural_1: null,
			rural_2: null,
			urban_1: null,
			urban_2: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['D', 'E', 'F', 'G'],
		excelValueRow: 77,
		priority: 217,
	},
	{
		id: 218,
		no: '2.3.6',
		label:
			'อัตราส่วนจำนวนครั้งการแสดงวีดีทัศน์แบบสตรีมมิ่งได้อย่างสมบูรณ์ (Streaming reproduction success ratio)',
		targeted_text: 'สำหรับ 4G (Resolution 720p) ยังไม่กำหนดค่าเป้าหมาย',
		subLabel_1: 'สำหรับ 4G (Resolution 720p) ยังไม่กำหนดค่าเป้าหมาย',
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		filling_condition:
			'ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: true,
		records: {
			rural_1: null,
			rural_2: null,
			urban_1: null,
			urban_2: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['D', 'E', 'F', 'G'],
		excelValueRow: 81,
		priority: 218,
	},
	{
		id: 219,
		no: '2.3.7',
		label:
			'ระยะเวลาที่ใช้ในการส่ง SMS จากฝั่งส่งไปยังฝั่งรับ (SMS end-to-end delivery time)',
		targeted_text:
			'ไม่เกิน 90 วินาที สำหรับร้อยละ 80 ของ SMS ที่ฝั่งรับได้รับสำเร็จภายใน Timeout ที่ 175 วินาที',
		subLabel_1: null,
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 90,
		targetCondition: null,
		filling_condition:
			'ข้อมูลที่กรอกจะต้องเป็นเลขจำนวนเต็ม และต้องมีค่ามากกว่าหรือเท่ากับ 0',
		isNeedAnswer: true,
		records: {
			rural_1: null,
			rural_2: null,
			urban_1: null,
			urban_2: null,
			avg: null,
			note: null,
		},
		data_type: 'int',
		excelValueCol: ['D', 'E', 'F', 'G'],
		excelValueRow: 86,
		priority: 219,
	},
	{
		id: 220,
		no: '2.3.8',
		label:
			'อัตราส่วนจำนวน SMS ที่ไปถึงฝั่งรับได้สำเร็จ (SMS completion success ratio)',
		targeted_text:
			'ไม่ต่ำกว่าร้อยละ 90 ของการทดสอบทั้งหมด จะต้องได้รับสำเร็จที่ฝั่งรับ ภายใน Timeout ที่ 175 วินาที',
		subLabel_1: null,
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 90,
		targetCondition: null,
		filling_condition:
			'ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ(มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: true,
		records: {
			rural_1: null,
			rural_2: null,
			urban_1: null,
			urban_2: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['D', 'E', 'F', 'G'],
		excelValueRow: 95,
		priority: 220,
	},
	{
		id: 221,
		no: '2.3.9',
		label:
			'ระยะเวลาที่ใช้ในการส่ง MMS จากฝั่งส่งไปยังฝั่งรับ (MMS end-to-end delivery time)',
		targeted_text:
			'ภายใน 5 นาที สำหรับร้อยละ 70 ของ MMS ที่ฝั่งรับได้รับสำเร็จภายใน Timeout ที่ 13 นาที',
		subLabel_1: null,
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 70,
		targetCondition: null,
		filling_condition:
			'ข้อมูลที่กรอกจะต้องเป็นเลขจำนวนเต็ม และต้องมีค่ามากกว่าหรือเท่ากับ 0',
		isNeedAnswer: true,
		records: {
			rural_1: null,
			rural_2: null,
			urban_1: null,
			urban_2: null,
			avg: null,
			note: null,
		},
		data_type: 'int',
		excelValueCol: ['D', 'E'],
		excelValueRow: 104,
		priority: 221,
	},
	{
		id: 222,
		no: '2.3.10',
		label:
			'อัตราส่วนจำนวน MMS ที่ไปถึงฝั่งรับได้สำเร็จ (MMS completion success ratio)',
		targeted_text:
			'ภายใน 5 นาที สำหรับร้อยละ 70 ของ MMS ที่ฝั่งรับได้รับสำเร็จภายใน Timeout ที่ 13 นาที',
		subLabel_1: null,
		subLabel_2: null,
		subLabel_3: null,
		subLabel_4: null,
		targetValue: 70,
		targetCondition: null,
		filling_condition:
			'ข้อมูลที่กรอกจะต้องมีหน่วยเป็นร้อยละ (มีค่าได้ตั้งแต่ 0.00 - 100.00)',
		isNeedAnswer: true,
		records: {
			rural_1: null,
			rural_2: null,
			urban_1: null,
			urban_2: null,
			avg: null,
			note: null,
		},
		data_type: 'float',
		excelValueCol: ['D', 'E'],
		excelValueRow: 113,
		priority: 222,
	},
]
// MAX ID 226